@let netSheetEnabled = netSheetEnabled$ | async;

<div class="tw:p-2">
  <ion-tabs (ionTabsDidChange)="setCurrentTab($event)">
    <div id="main-footer">
      @if (contactCardEnabled$ | async) {
        <red-contact-card></red-contact-card>
      }
      @if (propertyNavigationEnabled$ | async) {
        <red-property-navigator
          [walkingFarmId]="propertyNavigationWalkingFarmId"
          [propertyId]="propertyNavigationPropertyId"
        ></red-property-navigator>
      }
      <ion-tab-bar slot="bottom" color="primary" class="tw:pt-2 tw:pb-4">
        <ion-tab-button tab="{{ availableTabs.PropertySearch }}">
          <ion-icon
            [src]="
              activeTab === availableTabs.PropertySearch
                ? '/assets/svg/home-active.svg'
                : '/assets/svg/home-inactive.svg'
            "
            color="light"
          ></ion-icon>
          <ion-label color="light">Search</ion-label>
        </ion-tab-button>

        @if (walkingFarmEnabled$ | async) {
          <ion-tab-button tab="{{ availableTabs.WalkingFarm }}">
            <ion-icon
              [src]="
                activeTab === availableTabs.WalkingFarm
                  ? '/assets/svg/walking-farm-active.svg'
                  : '/assets/svg/walking-farm-inactive.svg'
              "
              color="light"
            ></ion-icon>
            <ion-label color="light">Walking Farm&#174;</ion-label>
          </ion-tab-button>
        }

        @if ((calculatorsEnabled$ | async) && netSheetEnabled === false) {
          <ion-tab-button tab="{{ availableTabs.Calculators }}">
            <ion-icon
              [src]="
                activeTab === availableTabs.Calculators
                  ? '/assets/svg/calculators-active.svg'
                  : '/assets/svg/calculators-inactive.svg'
              "
              color="light"
            ></ion-icon>
            <ion-label color="light">Calculators</ion-label>
          </ion-tab-button>
        }

        @if (netSheetEnabled) {
          <ion-tab-button tab="{{ availableTabs.NetSheet }}">
            <ion-icon
              [src]="
                activeTab === availableTabs.NetSheet
                  ? '/assets/svg/net-sheet-active.svg'
                  : '/assets/svg/net-sheet-inactive.svg'
              "
              color="light"
            ></ion-icon>
            <ion-label color="light">Net Sheet</ion-label>
          </ion-tab-button>
        }

        <ion-tab-button tab="{{ availableTabs.More }}">
          <ion-icon
            [src]="activeTab === availableTabs.More ? '/assets/svg/more-active.svg' : '/assets/svg/more-inactive.svg'"
            color="light"
          ></ion-icon>
          <ion-label color="light">More</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
      <div class="safe-area-bottom tw:relative"></div>
    </div>
  </ion-tabs>
</div>
